// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { components } from 'react-select';

const truncateLabel = (children, maxLength, sliceLength) => {
  const label = children == null ? '' : String(children);
  return label.length <= maxLength ? label : `${label.slice(0, sliceLength)}...`;
};

const CustomMultiValueLabel = ({ children, ...props }) => (
  <components.MultiValueLabel {...props}>
    {truncateLabel(children, 20, 17)}
  </components.MultiValueLabel>
);

export default CustomMultiValueLabel;
